import { Card, CardBody, Col, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ListsWithRadio } from "../../../../Constant";
import { LIST_RADIO_DATA, LIST_RADIO_LIST } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";

const ListsWithRadios = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={ListsWithRadio} span={LIST_RADIO_DATA} />
        <CardBody>
          <UL>
            <LI>
              <Input className="me-1 active checkbox-danger" type="radio" defaultChecked />
              <Label className="mb-0">Meditations</Label>
            </LI>
            {LIST_RADIO_LIST.map(({ color, text }, index) => (
              <LI key={index}>
                <Input className={`me-1 checkbox-${color}`} type="radio" />
                <Label className="mb-0">{text}</Label>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ListsWithRadios;
